import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

import { Student } from './shared/student';
import { FLOAT } from 'html2canvas/dist/types/css/property-descriptors/float';
//import { isNull } from '@angular/compiler/src/output/output_ast';
import { FormBuilder } from '@angular/forms';
import { year } from 'ag-charts-community/dist/esm/es6/util/time';

@Injectable({
  providedIn: 'root'
})

export class AdvancesService {
  userData: string[][];
  formData: Student = new Student();
  readonly baseURL = sessionStorage.getItem('NbaseURLs');
  baseURL_2 = 'https://localhost:44386/api';
  //constructor(private http: HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'my-auth-token'
    }),
  };
  constructor(private formBuilder: FormBuilder,private http: HttpClient) { }

  GetAllStudent() {
        return this.http.get(this.baseURL + '/GetAllStudents');
  }

  getData() {
    return sessionStorage.getItem('uname');
  }

  //////////////GetEmployeesID() {
  //////////////  return this.http.get(this.baseURL_2 + '/Employees/GetEmployeesID');
  //////////////}

  //GetStudentFeeDET(admno: string): Observable<Student> {
  //  const TransferObject = JSON.stringify(admno);
  //  return this.http.post<Student>(this.baseURL + '/GetStudentFeeDet?Admno=' + admno, TransferObject, this.httpOptions);
  //}

  CreateDuesFeeDet(admno: string, YearCode: number, todaydate: string): Observable<any> {
    debugger;
    return this.http.get<any>(this.baseURL + '/CreateDuesFeeDet?Admno=' + admno.toString() + '&&YearCode=' + YearCode + '&&UptoDate=' + todaydate.toString())
      .pipe(retry(1), catchError(this.handleError));
  }

  GetStudentFeeDETAdmno(admno: string): Observable<any> {
    debugger;
    return this.http.get<any>(this.baseURL + '/GetStudentFeeDetAdmno?Admno=' + admno.toString())
      .pipe(retry(1), catchError(this.handleError));
  }

  GetStudentFeeDETAdmnoDues(admno: string, YearCode: number): Observable<any> {
    debugger;
    //console.log(this.baseURL + '/GetStudentFeeDetAdmnoDues?Admno=' + admno.toString());
    return this.http.get<any>(this.baseURL + '/GetStudentFeeDetAdmnoDues?Admno=' + admno.toString() + '&&YearCode=' + YearCode)
      .pipe(retry(1), catchError(this.handleError));
  }

  GetStudentFeeDETAdmnoH(admno: any): Observable<any> {
    //GetStudentFeeDetAdmnoH
    return this.http.get<any>(this.baseURL + '/CreateDuesReceipt?Admno=' + admno)
      .pipe(retry(1), catchError(this.handleError));
  }

  OGetStudentFeeDetAdmno(admno: any): Observable<any> {
    return this.http.get<any>(this.baseURL + '/OGetStudentFeeDetAdmno')
      .pipe(retry(1), catchError(this.handleError));
  }

  GetLastTranAdded(): Observable<Student> {
    return this.http.get<Student>(this.baseURL + '/GetLastStatus')
      .pipe(retry(1), catchError(this.handleError));
  }

  //AddStduentTranFeesDet(_formdata: any[]): Observable<Student> {
  //  return this.http.put<Student>(this.baseURL_2 + '/PutEmployee111', _formdata, this.httpOptions)
  //}
  //formdata,string[] userInput,string[] userInputW, string UserCodeN, string FormType


  UpdateTemps03(AID: number, HeadCode: number, HeadAmt: number): Observable<any> {
    return this.http.get<any>(this.baseURL + '/UpdateTemps03?AID=' + AID + '&&HeadCode=' + HeadCode + '&&HeadAmt=' + HeadAmt);
  }

  AddStduentTranFeesAdvance(UserForm: any): Observable<any> {
    debugger;
    return this.http.post<any>(this.baseURL + '/AddStduentTranFeesAdvance', UserForm);
  }

  AddStduentTranFeesDet(_formdata: any[], userInput: any[], userInputW: any[], _formtype: string, _usercode: string): Observable<Student> {

    return this.http.get<Student>(this.baseURL + '/AddStduentTranFeesDet?userInput=' + userInput.toString())
    //return this.http.post<Student>(this.baseURL + '/AddStduentTranFeesDet?userInput=' + userInput + '&&userInputW=' + userInputW + '&&UserCodeN=' + _usercode + '&&FormType=' + _formtype, _formdata, this.httpOptions)
    //return this.http.post<Student>(this.baseURL + '/AddStduentTranFeesDet?formdata=' + _formdata + '&&userInput=' + userInput + '&&userInputW=' + userInputW + '&&UserCodeN=' + _usercode + '&&FormType=' + _formtype, _formdata, this.httpOptions)
    //return this.http.put<Student>(this.baseURL_2 + '/PutStudentFeeDet', _formdata, this.httpOptions)
  }

  //////////////GetEmployeesDET(id: any): Observable<Employee> {
  //////////////  return this.http.get<Employee>(this.baseURL_2 + '/Employees/GetEmployeesDET?id=' + id)
  //////////////    .pipe(retry(1), catchError(this.handleError));
  //////////////}

  //updateEmployeeDET(id: any, _employee: any): Observable<Employee> {
  //  return this.http.put<Employee>(this.baseURL_2 + '/Employees/PutEmployee?id=' + id, _employee, this.httpOptions)
  //}

  //public updateEmployee(postData: Object) {
  //  let endPoints = "/posts/1"
  //  this.http.put(this.baseURL_2 + '/Employees/PutEmployee?id=' + 1, postData).subscribe(data => {
  //    console.log(data);
  //  });
  //}


  ////////////AddEmployeeDET(updatedData: any[]): Observable<Employee> {
  ////////////  const transferObject = {
  ////////////    "name": "Yogesh Sharma", "age": 29, "designation": "Clerk", "mobileNumber": "7777423659", "c_Code": "C"
  ////////////  }

  ////////////  //const TransferObject = JSON.stringify(updatedData);

  ////////////  return this.http.post<Employee>(this.baseURL_2 + '/Employees/PostEmployee', transferObject, this.httpOptions)
  ////////////    .pipe(
  ////////////      catchError(this.handleError)
  ////////////    )
  ////////////}


  //////////////updateEmployeeDET(id: any, updatedData: any[]): Observable<Employee> {
  //////////////  //const transferObject = {
  //////////////  //  "id": 1, "name": "Mahesh Krs", "age": 19, "designation": "Clerk", "mobileNumber": "9854520000", "c_Code": "D"
  //////////////  //}

  //////////////  const TransferObject = JSON.stringify(updatedData);

  //////////////  return this.http.put<Employee>(this.baseURL_2 + '/Employees/PutEmployee?id2=' + id, TransferObject, this.httpOptions)
  //////////////    .pipe(
  //////////////      catchError(this.handleError)
  //////////////    )
  //////////////}




  //updateEmployeeDET(id: any, _employee: any): Observable<Employee> {
  //  return this.http.put<Employee>(this.baseURL_2 + '/Employees/PutEmployee?id=' + id,
  //  JSON.stringify(_employee),
  //  this.httpOptions
  //  )
  //  .pipe(retry(1), catchError(this.handleError));
  //}

  //updateEmployee(id: any,employee: any): Observable<Employee> {
  //  return this.http
  //    .put<Employee>(this.baseURL_2 + '/Employees/PutEmployee?id=' + id,
  //      JSON.stringify(employee),
  //      this.httpOptions
  //    )
  //    .pipe(retry(1), catchError(this.handleError));
  //}

  //updateEmployee(id: any, employee: any): Observable<Employee> {
  //  return this.http
  //    .put<Employee>(this.baseURL_2 + '/Employees/PutEmployee?id=' + id)     
  //    .pipe(retry(1), catchError(this.handleError));
  //}

  // Error handling
  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    // window.alert(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
  //  GetEmployeeDet() {
  //  return this.http.get(this.baseURL_2 + '/Employees/GetAll');
  //}

  //GetEmployeeDet() {
  //  return this.http.get(this.baseURL_2 + '/Employees/Index');

  //  return this.http.get<CategoryService>(this.baseURL_2 + '/Employees/Index');
  //}

  //GetEmployeeDet(): Observable<any[]> {
  //  return this.http.get<any[]>(this.baseURL_2 + '/Employees/GetAll');
  //}


  //GetAllCategory(): Observable<any[]> {
  //  /*return this.http.get<any>(this.baseURL + '/GetAllCategory')*/
  //  return this.http.get(this.baseURL + '/GetAllCategory')
  //    .pipe(map((resp: any) => resp.json()),
  //      //catchError(error => this.throwError(error))
  //    )
  //}
  //throwError(error: any) {
  //  console.error(error);
  //  return Observable.throw(error.json().error || 'Server error');
  //}
  }
